import { Divider, FormGroup, InputGroup } from '@blueprintjs/core'
import React from 'react'
import CategoryMarketCategoryPickerV2 from '../../../../components/Categories/CategoryMarketCategoryPickerV2'
import { GenericCheckbox } from '../../../../components/Inputs'
import BasicProductInfo from '../../components/BasicProductInfo'
import * as SgwInputs from './Inputs'
import CHANNELS from '../../../../constants/Channels'
import { OrganizationShippingSettings } from '../../../../current/types'

interface Props {
  doOfferAdditionalInfo: any
  form: any
  isConcurrent: boolean
  isDisabled: boolean
  isStockDisabled: boolean
  listingStrategyDisabled: boolean
  listingStrategyId?: number
  onFormChange: (k: string, value: any) => void
  onListingStrategyChange: (v: any) => void
  onProductChange: (k: string, value: any) => void
  onSkuParseLoading?: (loading: boolean) => void
  product: any
  shippingSettings?: OrganizationShippingSettings
}

export default class Form extends React.PureComponent<Props, {}> {
  render() {
    const {
      form,
      isDisabled,
      isStockDisabled,
      isConcurrent,
      doOfferAdditionalInfo,
      listingStrategyDisabled,
      product,
      listingStrategyId,
      onListingStrategyChange
    } = this.props

    const isRepricing = product?.isMedia && product?.isRepricingPaused === false
    const isListingStrategyDisabled = listingStrategyDisabled || isRepricing

    return (
      <div>
        <h4>Product Info</h4>

        <div style={{ display: 'grid', gridTemplateColumns: '65%' }}>
          <CategoryMarketCategoryPickerV2
            marketId={1}
            disabled={isDisabled}
            label="Category"
            value={form.categoryMarketCategoryId}
            onChange={v => this.props.onFormChange('categoryMarketCategoryId', v)}
          />

          <BasicProductInfo
            isDisabled={isDisabled}
            channel={CHANNELS.SHOPGOODWILL}
            listingId={form.id}
            doOfferAdditionalInfo={doOfferAdditionalInfo}
            onChange={this.props.onProductChange}
            shippingSettings={this.props.shippingSettings}
            parseSkuQRCodePayloads
            onSkuParseLoading={this.props.onSkuParseLoading}
            {...this.props.product}
          />
        </div>
        <>
          <Divider style={{ margin: '20px 0 10px' }} />
          <h4>Listing Strategy</h4>
          <div style={{ margin: '20px auto', display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '8px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
              <SgwInputs.ListingStrategies
                onChange={onListingStrategyChange}
                value={listingStrategyId}
                disabled={isListingStrategyDisabled}
                title="Listing Strategy"
              />
              {isRepricing && (
                <div style={{ marginTop: '1px', fontSize: '12px', color: '#666' }}>This is being repriced.</div>
              )}
            </div>
          </div>
        </>
        <h4>Shopgoodwill Info</h4>
        <div style={{ margin: '20px auto', display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)' }}>
          <div>
            <FormGroup
              style={{ maxWidth: 197 }}
              label="Seller Private Description"
              helperText={
                <a
                  role="button"
                  tabIndex={0}
                  onClick={() => this.props.onFormChange('sellerPrivateDescription', this.props.product.sku)}
                >
                  Copy from SKU
                </a>
              }
            >
              <InputGroup
                onChange={e => this.props.onFormChange('sellerPrivateDescription', e.target.value)}
                value={form.sellerPrivateDescription}
                placeholder="2019561246"
              />
            </FormGroup>
            {!isConcurrent && (
              <SgwInputs.StartingBid
                disabled={isDisabled}
                value={form.startingBid}
                onChange={v => this.props.onFormChange('startingBid', v)}
              />
            )}
            {!isConcurrent && (
              <SgwInputs.BidIncrement
                value={form.bidIncrement}
                disabled={isDisabled}
                onChange={v => this.props.onFormChange('bidIncrement', v)}
              />
            )}
            <GenericCheckbox
              title="No Combine Shipping"
              value={form.noCombineShipping}
              onChange={v => this.props.onFormChange('noCombineShipping', v)}
            />
            <GenericCheckbox
              title="Featured Item"
              value={form.itemFeatured}
              disabled={isDisabled}
              onChange={v => this.props.onFormChange('itemFeatured', v)}
            />
          </div>
          <div>
            <SgwInputs.AuctionStart
              value={form.auctionStart}
              disabled={isDisabled}
              onChange={v => this.props.onFormChange('auctionStart', v)}
            />
            {!isConcurrent && (
              <SgwInputs.ReservePrice
                value={form.reservePrice}
                disabled={isDisabled}
                onChange={v => this.props.onFormChange('reservePrice', v)}
              />
            )}
            <SgwInputs.BuyNowPrice
              disabled={isDisabled}
              value={form.buyNowPrice}
              onChange={v => this.props.onFormChange('buyNowPrice', v)}
            />
            <SgwInputs.StockQuantity
              value={form.stockQuantity}
              disabled={isStockDisabled}
              onChange={v => this.props.onFormChange('stockQuantity', v)}
            />
          </div>
          <div>
            <SgwInputs.AuctionDuration
              value={form.auctionDuration}
              disabled={isDisabled || isConcurrent}
              buyNowPrice={form.buyNowPrice}
              onChange={v => this.props.onFormChange('auctionDuration', v)}
              isListed={form?.state === 'LISTED'}
            />
            <SgwInputs.HandlingPrice
              value={form.handlingPrice}
              onChange={v => this.props.onFormChange('handlingPrice', v)}
            />
            <SgwInputs.ShippingPrice
              value={form.shippingPrice}
              onChange={v => this.props.onFormChange('shippingPrice', v)}
            />
          </div>
        </div>
      </div>
    )
  }
}
